module.exports = __webpack_public_path__ + "static/media/master.29e4cbb7.jpg";